import Vue from 'vue'
import { lowerCase, has, get } from 'lodash-es'
import { stringSplice } from '@/js/helper/string-splice.js'

import STORE_CONSTANTS from '../../utils/store-constants'

import TYPES from './mutation-types'
import CONST from './brands-constants'

const transformSvg = (data, pimId) => {
  return stringSplice(data.replace(/^<\?xml.*\n?/m, ''), 4, 0, ` id="logo-${pimId.toLowerCase()}"`)
}

export default {
  [TYPES.SET_BRAND]: (state, { id, brand }) => {
    // Set id + brand
    Vue.set(state[STORE_CONSTANTS.BY_ID], id, { ...brand, id })
    state[STORE_CONSTANTS.ALL_IDS].push(id)

    // Set pim id
    const pimId = lowerCase(brand[CONST.PIM_BRAND_NAME])
    if (pimId) {
      Vue.set(state[CONST.BY_PIM_ID], pimId, id)
      state[STORE_CONSTANTS.ALL_IDS].push(pimId)
    }
  },
  [TYPES.SET_BRAND_PROMISE]: (state, { brand, promise }) => {
    if (!has(state, [STORE_CONSTANTS.BY_ID, brand])) {
      return
    }
    Vue.set(state[STORE_CONSTANTS.BY_ID][brand], CONST.LOGO_PROMISE, promise)
  },
  [TYPES.SET_BRAND_LOGO]: (state, { brand, data }) => {
    const pimId = get(state, [STORE_CONSTANTS.BY_ID, brand, CONST.PIM_BRAND_NAME])
    const viewBox = get(data.match(/viewBox="([\d\s.]+)"/i), 1)
    Vue.set(state[STORE_CONSTANTS.BY_ID][brand], CONST.LOGO_VIEWBOX, viewBox)
    Vue.set(state[STORE_CONSTANTS.BY_ID][brand], CONST.LOGO_DATA, transformSvg(data, pimId))
  },
}
